import { render, staticRenderFns } from "./ButtonName.vue?vue&type=template&id=22e002b7&scoped=true&"
import script from "./ButtonName.vue?vue&type=script&lang=js&"
export * from "./ButtonName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e002b7",
  null
  
)

export default component.exports